import React from 'react';

const UseTab = props => {
    
    const {
        tabClick,
    } = props;

    return (
        <React.Fragment>
            <ul className="tab-nav tab-type2">
                <li data-tab="con-tab1" onClick={() => tabClick('menu')}>
                    <span className="tab">메뉴별 사용 통계현황</span>
                </li>
                <li data-tab="con-tab2"  className="active">
                    <span className="tab">지점별 로그인 현황</span>
                </li>
            </ul>                                    
        </React.Fragment>
    );
};


export default UseTab;
